import React, { useEffect, useRef, useState } from "react";
import Player from "@vimeo/player";
import PropTypes from "prop-types";
import { translate } from "pdf-lib";

const VimeoPlayer = ({ videoId, onVideoEnd }) => {
  const containerRef = useRef(null);
  const [playerInstance, setPlayerInstance] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    if (!videoId || !containerRef.current) return;

    // Clean up previous player DOM if any
    containerRef.current.innerHTML = "";

    // Create a fresh div inside container for iframe
    const iframeDiv = document.createElement("div");
    containerRef.current.appendChild(iframeDiv);

    const player = new Player(iframeDiv, {
      id: videoId.trim(),
      width: 1240,
      controls: false,
      autoplay: false,
    });

    setPlayerInstance(player);

    const handlePlay = async () => {
      const time = await player.getCurrentTime();

      if (time < 1) {
        setTimeout(() => player.setVolume(1), 500);
        setIsPlaying(true);
      }
    };

    const handleEnded = () => {
      setIsPlaying(false);
      onVideoEnd?.();
    };

    player.on("play", handlePlay);
    player.on("ended", handleEnded);

    return () => {
      player.off("play", handlePlay);
      player.off("ended", handleEnded);
      player.destroy().catch(() => {});
      setPlayerInstance(null);
    };
  }, [videoId, onVideoEnd]);

  const togglePlayPause = async () => {
    if (!playerInstance) return;
    const isPaused = await playerInstance.getPaused();
    if (isPaused) {
      await playerInstance.play();
      setIsPlaying(true);
    } else {
      await playerInstance.pause();
      setIsPlaying(false);
    }
  };

  return (
    <div style={{textAlign: "center" }}>
      <div ref={containerRef} className="vimeo-iframe" />
      <button
        onClick={togglePlayPause}
        style={{
          backgroundColor: "#ff0000",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          width: "100px",
          transform: "translate(0, -100px)",
        }}
      >
        {isPlaying ? (
          <i className="fa-solid fa-pause"></i>
        ) : (
          <i className="fa-solid fa-play"></i>
        )}
      </button>
    </div>
  );
};

VimeoPlayer.propTypes = {
  videoId: PropTypes.string.isRequired,
  onVideoEnd: PropTypes.func,
};

export default VimeoPlayer;
